import { render, staticRenderFns } from "./packageCategory.vue?vue&type=template&id=da08c40a&scoped=true"
import script from "./packageCategory.vue?vue&type=script&lang=js"
export * from "./packageCategory.vue?vue&type=script&lang=js"
import style0 from "./packageCategory.vue?vue&type=style&index=0&id=da08c40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da08c40a",
  null
  
)

export default component.exports